import React, { useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Password } from "primereact/password";
import axios from '../axios';
import Cookies from 'js-cookie';

const Login = ({ toast, setBlocked, setLogin }) => {
    const defaultValues = { value: '' };
    const form = useForm({ defaultValues });
    const errors = form.formState.errors;

    const onSubmit = async (data) => {
        setBlocked(true)
        try {
			const response_message = await axios.post('/login', { password: data.value });
			if (response_message.data.success) {
				toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Login successful!', life: 3000 });
                const maxExpiryDate = new Date(2038, 0, 19, 3, 14, 7);
                Cookies.set('token', response_message.data.token, { expires: maxExpiryDate, sameSite:'strict', path: process.env.REACT_APP_SUBFOLDER});
                setLogin(true)
			}
			else {
				toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid password!', life: 3000 });
			}
		}
		catch (error) {
			toast.current.show({ severity: 'error', summary: 'Error', detail: 'Connection failed!', life: 3000 });
		}
		setBlocked(false)
    };

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    return (
        <div className="card flex justify-content-center w-full h-full pt-8">
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column gap-2">
                <h1>Login</h1>
                <Controller
                    name="value"
                    control={form.control}
                    rules={{ required: 'Password is required.' }}
                    render={({ field, fieldState }) => (
                        <>
                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}>Password</label>
                            <Password id={field.name} {...field} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} feedback={false} toggleMask />
                            {getFormErrorMessage(field.name)}
                        </>
                    )}
                />
                <Button label="Submit" type="submit" icon="pi pi-check" />
            </form>
        </div>
    );
}

export default Login; 